import React, { useState, useEffect } from 'react';
import Header from './../../components/user/common/Header';
import PageTitle from './../../components/user/common/PageTitle';
import ServiceSidebar from './../../components/user/common/ServiceSidebar';
import Footer from './../../components/common/Footer';
import ListingHead from './../../components/user/common/ListingHead';
import ServiceCard from './../../components/common/ServiceCard';
import { NotFound } from './../../components/common/NotFound';
import SpinnerLoader from './../../components/common/SpinnerLoader';
import config from './../../config.json';
import axios from 'axios';
import { Link, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setProducts, setReqBody, setTotalProducts, setMaxPrice } from './../../store/reducers/product-reducer';
import { setLoading } from './../../store/reducers/global-reducer';
import readUrl from './../../helpers/read-product-listing-url';
import { getBrands, getColors } from './../../helpers/product-listing';
import { Helmet } from 'react-helmet';
import GoToTop from './../../helpers/GoToTop';
import arrow_back from '../../assets/icons/arrow-back.svg'

const ServicesListing = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const category = queryParams.get("cat");
    const searchQuery = queryParams.get("searchText");
    const subCat = queryParams.get("subcat");
    const reqBodyFromStore = useSelector(state => state.product.reqBody);

    const { totalProducts } = useSelector(state => state.product);
    const { selectedWishItems } = useSelector(state => state.wishlist);
    const [reqBody, setReqBodyState] = useState(JSON.parse(JSON.stringify(reqBodyFromStore)));
    const [services, setServicesState] = useState([]);
    const [loading, setLoading] = useState(true);
    const [priceRange, setPriceRange] = useState();
    const [selectedCategories, setSelectedCategories] = useState(
        () => (category ? [category] : [])
    );
    const [categories, setCategories] = useState('')
    const [sideBarToggle, setSideBarToggle] = useState(false);
    
    // ADDED: Simple sorting state (default to ranking)
    const [sortBy, setSortBy] = useState('ranking');

    useEffect(() => {
        if (!category) {
            setSelectedCategories([]);
        } else {
            setSelectedCategories((prev) =>
                prev.length === 1 && prev[0] === category ? prev : [category]
            );
        }
    }, [category]);

    useEffect(() => {
        axios.get("front/getServiceCategory")
            .then((response) => {
                if (response.data.status) {
                    setCategories(response.data.data);
                } else {
                    console.log("Error")
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let reqBodyUpdated = { ...reqBody };
        reqBodyUpdated = readUrl(dispatch, reqBodyUpdated, window.location, setReqBody, 'service-listing');
        setReqBodyState(reqBodyUpdated);
    }, []);

    useEffect(() => {
        getServices()
    }, [priceRange, selectedCategories, searchQuery, category, sortBy]) // ADDED: sortBy to dependencies

    const handlePriceRangeChange = (range) => {
        setPriceRange(range);
    };

    const handleCategoryChange = (categories) => {
        setSelectedCategories(categories);
    };

    const handleSubCategoryChange = (categories) => {
        // setSelectedSubCategories(categories);
    };

    const handleBrandChange = (brands) => {
        // setSelectedBrands(brands);
    };

    // ADDED: Simple sort handler
    const handleSortChange = (newSortBy) => {
        setSortBy(newSortBy);
    };

    const getServices = () => {
        setLoading(true); // Start loading

        try {
            // MODIFIED: Check if we can use the ranking endpoint (no filters applied)
            const hasFilters = priceRange || 
                             selectedCategories.length > 0 || 
                             searchQuery || 
                             category;

            if (sortBy === 'ranking' && !hasFilters) {
                // ADDED: Use the new ranking endpoint when no filters and sorting by ranking
                axios.get('front/services/ranked?limit=50')
                    .then((response) => {
                        if (response.data.success) {
                            const servicesData = response.data.data.map(service => ({
                                id: service._id,
                                image: service.featuredImage,
                                name: service.name,
                                isService: true, // Services are always services
                                price: service.charges,
                                avgRating: service.avgRating || 0,
                                // ADDED: Include ranking data
                                ranking: service.ranking,
                                badge: service.badge
                            }));

                            setServicesState(servicesData);
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching ranked services:", error);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            setLoading(false);
                        }, 300);
                    });
            } else {
                // KEEP EXISTING: Use your original endpoint with filters
                let servicesData = [];
                let reqBodyUpdated = {
                    "priceRange": priceRange,
                    "selectedCategories": selectedCategories,
                    "searchQuery": searchQuery,
                    // ADDED: Send sort preference to backend
                    "sortBy": sortBy
                };

                axios.post('front/service/listing', reqBodyUpdated).then((response) => {
                    if (response.data.status) {
                        let res = response.data.data;
                        res.forEach(service => {
                            servicesData.push({
                                id: service.id,
                                image: service.featuredImage,
                                name: service.name,
                                isService: service.isService,
                                price: service.charges,
                                avgRating: service.avgRating,
                                // ADDED: Include ranking data if available
                                ranking: service.ranking,
                                badge: service.badge
                            });
                        });
                    }
                    setServicesState(servicesData);
                }).catch(error => {
                    if (error.response && error.response.data.status === false) {
                        // dispatch(setProducts({ products: [] }));
                    }
                }).finally(() => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 300);
                });
            }
        } catch (error) {
            console.error("Error in getServices:", error);
            setLoading(false);
        }
    }

    return (
        <React.Fragment>
            <Helmet><title>{"Services - Pay Earth"}</title></Helmet>
            {loading === true ? <SpinnerLoader /> : ''}
            <Header
                pageName="service-listing"
                reqBody={reqBody}
            />
            <PageTitle title={"Services"} />
            <section className="inr_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-3 d-flex justify-content-between align-items-center flex-wrap">
                            <div className="pt-2 d-flex flex-wrap gap-3">
                                <span className="text-uppercase fw-bold">CATEGORIES: {categories.length || 0}</span>
                                <span className="text-uppercase fw-bold">SERVICES: {services.length || 0}</span>
                            </div>

                            <div className="d-flex align-items-center gap-3">
                                {/* ADDED: Simple sort dropdown */}
                                <div className="sort-dropdown">
                                    <label htmlFor="sortSelect" className="form-label mb-0 me-2">Sort by:</label>
                                    <select 
                                        id="sortSelect"
                                        className="form-select form-select-sm"
                                        value={sortBy}
                                        onChange={(e) => handleSortChange(e.target.value)}
                                        style={{ minWidth: '150px' }}
                                    >
                                        <option value="ranking">Best Ranked</option>
                                        <option value="avgRating">Highest Rated</option>
                                        <option value="newest">Newest First</option>
                                        <option value="price_low">Price: Low to High</option>
                                        <option value="price_high">Price: High to Low</option>
                                    </select>
                                </div>

                                <button
                                    type="button"
                                    className="btn custum_back_btn btn_yellow d-flex align-items-center"
                                    onClick={() => window.history.back()}
                                >
                                    <img src={arrow_back} alt="back" className="me-2" />
                                    Back
                                </button>
                            </div>
                        </div>
                        
                        <div className="col-md-3 mt-3" style={{ overflowY: 'auto', maxHeight: '120vh', border: '1px solid #ddd', scrollbarWidth: 'thin', }}>
                            <div className='mob-show'>
                                <button className="filter-mob-catShow px-2" type="button" aria-controls="navbarExampleOnHover" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setSideBarToggle(prevState => !prevState)}><span className="fa fa-bars"></span> Filter</button>
                            </div>
                            <ServiceSidebar pageName="service-listing"
                                sideBarToggle={sideBarToggle}
                                categories={categories}
                                onPriceRangeChange={handlePriceRangeChange}
                                onCategoryChange={handleCategoryChange}
                            />
                        </div>
                        
                        <div className="col-md-9 my-3" style={{ overflowY: 'auto', maxHeight: '120vh', border: '1px solid #ddd', scrollbarWidth: 'thin', }}>
                            <div className="row">
                                <div className="col-sm-12">
                                    {services.length === 0 ? <NotFound msg="Service not found." /> : ''}
                                    <div className="cards_wrapper">
                                        {
                                            services.map((service, index) => {
                                                // Function to get custom badge text for top 3
                                                const getCustomBadge = (index, sortBy) => {
                                                    if (sortBy === 'ranking') {
                                                        if (index === 0) return "Best Seller";
                                                        if (index === 1) return "Popular Choice";
                                                        if (index === 2) return "Fan Favourite";
                                                    }
                                                    return null;
                                                };

                                                const customBadge = getCustomBadge(index, sortBy);

                                                return (
                                                    <div key={index} className="service-wrapper position-relative">
                                                        {/* Show custom badge for top 3 services */}
                                                        {customBadge && (
                                                            <div className={`service-badge custom-badge-${index + 1}`}>
                                                                {customBadge}
                                                            </div>
                                                        )}

                                                        <ServiceCard
                                                            data={service}
                                                        />
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ADDED: Simple CSS for badges */}
            <style jsx>{`
                .service-wrapper {
                    position: relative;
                }
                
                .service-badge {
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    color: white;
                    z-index: 9;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
                }
                
                /* Custom badges for top 3 services */
                .custom-badge-1 {
                    background: linear-gradient(45deg, #e74c3c, #c0392b);
                    border: 2px solid #fff;
                }
                
                .custom-badge-2 {
                    background: linear-gradient(45deg, #f39c12, #e67e22);
                    border: 2px solid #fff;
                }
                
                .custom-badge-3 {
                    background: linear-gradient(45deg, #27ae60, #229954);
                    border: 2px solid #fff;
                }
                
                .sort-dropdown {
                    display: flex;
                    align-items: center;
                }
                
                @media (max-width: 768px) {
                    .service-badge {
                        font-size: 8px;
                        padding: 2px 6px;
                    }
                    
                    .ranking-badge {
                        width: 20px;
                        height: 20px;
                        font-size: 9px;
                    }
                }
            `}</style>

            <Footer />
            <GoToTop />
        </React.Fragment>
    );
}

export default ServicesListing;